import React from 'react';
import cls from 'classnames';

import { IconComp } from '../IconComponent';

import { ReactComponent as KiwiHand } from '../../../assets/svg/icons/kiwi-hand.svg';
import { ReactComponent as Hanger } from '../../../assets/svg/icons/hanger.svg';
import { ReactComponent as ERC721 } from '../../../assets/svg/stickers/Signs/Sign_ERC721.svg';
import { ReactComponent as ERC1155 } from '../../../assets/svg/stickers/Signs/Sign_ERC1155.svg';
import { ReactComponent as ScamFree } from '../../../assets/svg/stickers/Signs/Sign_scamfree_hardcoded.svg';
import { ReactComponent as RightArrow } from '../../../assets/svg/icons/arrow-right.svg';
import { ButtonSizes, SKButton } from '../Button';
import { Routes } from '../../../constants/routes';
import { useHistory } from 'react-router-dom';
import { useBreakpoint } from '../../../hooks/useBreakpoint';

// TODO: rename this to be component specific
export enum BackgroundColor {
  KIWI = 'kiwi',
  CLOUD = 'cloud',
  GRAPE = 'grape',
  LEMON = 'lemon',
  POMELO = 'pomelo',
}

export enum ImagePosition {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  CENTER = 'center',
}

export interface IContentInCard {
  rotation: number;
}

export interface ITextWithImage {
  background: BackgroundColor;
  image: React.ReactType;
  imagePosition: ImagePosition;
  contentInCard?: IContentInCard | null;
  content: string;
}
export const TextWithImage: React.FC<ITextWithImage> = (props) => {
  const { background, image, imagePosition, contentInCard, content } = props;
  const isBiggerThanMobile = useBreakpoint('48em');
  const history = useHistory();

  return (
    <div
      className={cls('border-b border-cloud-900', {
        'bg-cloud-900 text-white': background === BackgroundColor.CLOUD,
        'bg-kiwi-400': background === BackgroundColor.KIWI,
        'bg-lemon-400': background === BackgroundColor.LEMON,
        'bg-grape-500': background === BackgroundColor.GRAPE,
        'bg-pomelo-400': background === BackgroundColor.POMELO,
      })}
    >
      <div className="flex app-container mx-auto flex-wrap justify-center gap-y-2 gap-x-6 xl:justify-around md-and-below:py-10 p-2 items-center min-h-46.5">
        {isBiggerThanMobile && (
          <IconComp className={cls({ 'order-2': imagePosition === ImagePosition.RIGHT })} icon={image} size={670} />
        )}
        {contentInCard && (
          <div
            className={cls(
              'relative',
              `transform xs-only:transform-none ${
                contentInCard.rotation > 0
                  ? `rotate-${contentInCard.rotation}`
                  : `-rotate-${Math.abs(contentInCard.rotation)}`
              }`,
            )}
          >
            <div
              className={cls(
                'card-content max-w-xl rounded-xl border border-cloud-900 bg-onion-50 px-8 xs-only:px-2.5 py-10',
              )}
            >
              <div dangerouslySetInnerHTML={{ __html: content }}></div>
              <SKButton
                className="mt-2 xs-only:w-full"
                color="primary"
                size={isBiggerThanMobile ? ButtonSizes.XXL : ButtonSizes.XL}
                iconRight={RightArrow}
                onClick={(): void => history.push(Routes.FAQ)}
              >
                <p>How it Works</p>
              </SKButton>
            </div>
            <IconComp
              className={cls('fill-current absolute top-0 transform -translate-x-1/2 left-1/2', {
                'text-cloud-900 text-white': background === BackgroundColor.CLOUD,
                'text-kiwi-400': background === BackgroundColor.KIWI,
                'text-lemon-400': background === BackgroundColor.LEMON,
                'text-grape-500': background === BackgroundColor.GRAPE,
                'text-pomelo-400': background === BackgroundColor.POMELO,
              })}
              icon={Hanger}
              size={88}
            />
            {isBiggerThanMobile && <IconComp className="absolute -top-8 left-7" icon={KiwiHand} size={159} />}
            <IconComp
              className="absolute xs-only:-bottom-10 -bottom-17 xs-only:right-2 right-8 transform rotate-6 text-lemon-400 fill-current"
              icon={ERC1155}
              size={isBiggerThanMobile ? 200 : 160}
            />
            <IconComp
              className="absolute text-pomelo-400 fill-current xs-only:-bottom-10 -bottom-15 transform -rotate-6 xs-only:left-1 left-9"
              icon={ERC721}
              size={isBiggerThanMobile ? 218 : 160}
            />

            <IconComp
              className="absolute -top-12 transform rotate-3 -right-2"
              icon={ScamFree}
              size={isBiggerThanMobile ? 200 : 170}
            />
          </div>
        )}
        {!contentInCard && <div className="lg:max-w-43" dangerouslySetInnerHTML={{ __html: content }}></div>}
      </div>
    </div>
  );
};
